export default __webpack_public_path__ + "static/media/twitterIcon.3d02804e.svg";